import { MetricChart } from '../../charts/MetricChart';
import { useMetric } from '../../hooks';
import type { WidgetSpec } from '../../dashboard/spec';
import styles from './Dashboard.module.scss';

export const MetricWidget = ({ spec }: { spec: WidgetSpec }) => {
  const { data, isLoading, error } = useMetric(spec);
  if (isLoading) {
    return <div className={styles.loading}>Loading…</div>;
  }
  if (error || !data) {
    return (
      <div className={styles.loading}>
        Could not load: {(error as { message?: string })?.message ?? 'unknown error'}
      </div>
    );
  }
  if (data.points.length === 0) {
    return <div className={styles.loading}>No data yet.</div>;
  }
  return <MetricChart result={data} chart={spec.chart} limit={spec.limit} />;
};
